import React, { useState } from "react";
import {
    Mail,
    User,
    Lock,
    Eye,
    EyeOff,
} from "lucide-react";

import { auth } from "./../firebase.js";

import {

    createUserWithEmailAndPassword,

    GoogleAuthProvider,

    signInWithPopup,

} from "firebase/auth";

import { signupRestaurant } from "../services/auth";

import { useNavigate } from "react-router-dom";

export function SignUp() {

    const [formData, setFormData] = useState({

        fullName: "",

        email: "",

        password: "",

        confirmPassword: "",

    });

    const [showPassword, setShowPassword] = useState(false);

    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const navigate = useNavigate();

    function handleChange(event) {

        setFormData({

            ...formData,

            [event.target.name]: event.target.value,

        });

    }

    async function handleSubmit(event) {

        event.preventDefault();

        if (
            formData.password !==
            formData.confirmPassword
        ) {

            alert("Passwords do not match.");

            return;

        }

        try {

            const credential =
                await createUserWithEmailAndPassword(

                    auth,

                    formData.email,

                    formData.password

                );

            const idToken =
                await credential.user.getIdToken();

            await signupRestaurant(idToken, formData.fullName);

            navigate("/business-details");

        }

        catch (error) {

            console.error(error);

            alert(error.message);

        }

    }

    async function handleGoogleSignup() {

        try {

            const provider =
                new GoogleAuthProvider();

            const result =
                await signInWithPopup(

                    auth,

                    provider

                );

            const idToken =
                await result.user.getIdToken();

            await signupRestaurant(idToken, formData.fullName);

            navigate("/business-details");

        }

        catch (error) {

            console.error(error);

            alert(error.message);

        }

    }

    return (

        <div className="signup-page">

            {/* Left Panel */}

            <div className="signup-left">

                <div className="signup-brand">

                    <img
                        src={require("./../imgs/nextgo-logo.png")}
                        alt="Next Go Logo"
                        className="signup-logo"
                    />

                    <h2>

                        NextGo

                    </h2>

                </div>

                <div className="signup-left-content">

                    <h1>

                        Turn every purchase
                        <br />
                        into customer acquisition

                    </h1>

                    <p>

                        Place your offers on other businesses' checkouts and grow your customer base.

                    </p>

                    <div className="signup-dashboard-preview">

                        <img src={require('./../imgs/dashboard-preview.png')} alt='Dashboard Preview' />

                    </div>

                </div>

            </div>

            {/* Right Panel */}

            <div className="signup-right">

                <div className="signup-top-link">

                    Already have an account?

                    <a href="/login">

                        Log in

                    </a>

                </div>

                <div className="signup-form-container">

                    <h1>

                        Create your account

                    </h1>

                    <p className="signup-subtitle">

                        Take the first step to grow your business.

                    </p>

                    <form onSubmit={handleSubmit}>

                        {/* Full Name */}

                        <label>

                            Full Name

                        </label>

                        <div className="input-group">

                            <User
                                size={20}
                                className="input-icon"
                            />

                            <input
                                type="text"
                                name="fullName"
                                placeholder="Enter your full name"
                                value={formData.fullName}
                                onChange={handleChange}
                            />

                        </div>

                        {/* Email */}

                        <label>

                            Email Address

                        </label>

                        <div className="input-group">

                            <Mail
                                size={20}
                                className="input-icon"
                            />

                            <input
                                type="email"
                                name="email"
                                placeholder="Enter your email address"
                                value={formData.email}
                                onChange={handleChange}
                            />

                        </div>

                        {/* Password */}

                        <label>

                            Password

                        </label>

                        <div className="input-group">

                            <Lock
                                size={20}
                                className="input-icon"
                            />

                            <input
                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }
                                name="password"
                                placeholder="Create a password"
                                value={formData.password}
                                onChange={handleChange}
                            />

                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() =>
                                    setShowPassword(!showPassword)
                                }
                            >

                                {showPassword
                                    ? <EyeOff size={20} />
                                    : <Eye size={20} />}

                            </button>

                        </div>

                        {/* Confirm Password */}

                        <label>

                            Confirm Password

                        </label>

                        <div className="input-group">

                            <Lock
                                size={20}
                                className="input-icon"
                            />

                            <input
                                type={
                                    showConfirmPassword
                                        ? "text"
                                        : "password"
                                }
                                name="confirmPassword"
                                placeholder="Confirm your password"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                            />

                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() =>
                                    setShowConfirmPassword(
                                        !showConfirmPassword
                                    )
                                }
                            >

                                {showConfirmPassword
                                    ? <EyeOff size={20} />
                                    : <Eye size={20} />}

                            </button>

                        </div>

                        <button
                            type="submit"
                            className="signup-button"
                        >

                            Create Account

                        </button>

                    </form>

                    <div className="signup-divider">

                        <span>

                            or

                        </span>

                    </div>

                    <button
                        className="google-button"
                        onClick={handleGoogleSignup}
                    >

                        <img
                            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                            alt="Google"
                        />

                        Sign up with Google

                    </button>

                    <p className="signup-terms">

                        By signing up, you agree to our{" "}

                        <a href="/terms">

                            Terms of Service

                        </a>

                        {" "}and{" "}

                        <a href="/privacy">

                            Privacy Policy

                        </a>

                        .

                    </p>

                </div>

            </div>

        </div>

    );

}